module.exports = __webpack_public_path__ + "static/img/report-null2.99f3419f.png";